import i18nFactory from '@yandex-int/i18n';
import { get } from 'lodash';
import * as queryString from 'querystring';

import { Fetch } from '../../service/Captcha/Captcha';
import { ApiMethodExecutingError } from '../../service/Errors';

import * as keyset from './PythonRestApiMethodExecutor.i18n';

const restI18N = i18nFactory(keyset);

type HttpMethod = 'POST' | 'GET';

interface ApiMethodOptions {
    method: HttpMethod;
    contentType?: string;
    credentials?: RequestCredentials;
    mode?: RequestMode;
}

interface ExecuteApiMethodParams<Params> {
    methodPath: string;
    params: Params;
    options?: ApiMethodOptions;
    limit?: number;
}

const defaultApiMethodOptions: ApiMethodOptions = {
    method: 'POST',
    credentials: 'same-origin',
    mode: 'cors'
};

const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
};

export class PythonRestApiMethodExecutor {
    private baseUrl: string;
    private fetch: Fetch;

    constructor(baseUrl: string, fetch: Fetch) {
        this.baseUrl = baseUrl;
        this.fetch = fetch;
    }

    async executeApiMethod<Params, Result>({
        methodPath,
        params,
        options
    }: ExecuteApiMethodParams<Params>): Promise<Result> {
        return await this.makeRequest<Params, Result>({
            methodPath,
            params,
            options
        });
    }

    private getUrl(params: {}): string {
        const queryParams = queryString.stringify(get(params, 'query'));

        return `${this.baseUrl}?${queryParams}`;
    }

    private async makeRequest<Params, Result>({ params }: ExecuteApiMethodParams<Params>): Promise<Result> {
        const url: string = this.getUrl(params);
        const requestParams = Object.assign({}, defaultApiMethodOptions, {
            header: defaultHeaders,
            ...(params as {})
        }) as {};

        try {
            const response = await this.fetch(url, requestParams);
            const data = await response.json();

            return data;
        } catch (error) {
            const message = error.name === 'requestError' ? error.message : restI18N('request-error');

            throw new ApiMethodExecutingError({ message });
        }
    }
}
